import {capitalize, toUpper} from 'lodash';
import {FormProvider, useForm} from 'react-hook-form';

import ButtonPanel from 'components/Button/Panel';
import FormCancel from 'components/form/Cancel';
import FormCombobox from 'components/form/Combobox';
import FormError from 'components/form/Error';
import FormSubmit from 'components/form/Submit';
import FormText from 'components/form/Text';
import {handleSubmitErrors} from 'components/form/utils';
import useAppContext from 'conf/AppContext';


export default function ProfileForm({data, readOnly, onSave, onClose}) {
  const appContext = useAppContext();

  const formMethods = useForm({
    defaultValues: {
      firstName: data?.firstName ?? '',
      lastName: data?.lastName ?? '',
      email: data?.email ?? '',
      linkedInUrl: data?.linkedInUrl ?? '',
      gender: {label: capitalize(data.gender), value: capitalize(data.gender)},
      phone: data?.phone ?? '',
    },
    values: {
      firstName: data?.firstName ?? '',
      lastName: data?.lastName ?? '',
      email: data?.email ?? '',
      linkedInUrl: data?.linkedInUrl ?? '',
      gender: {label: capitalize(data.gender), value: capitalize(data.gender)},
      phone: data?.phone ?? '',
    },
  });

  
  const {handleSubmit, setError} = formMethods;

  
  const onSubmit = async (values) => {
    try {
      const rez = await appContext.api.put('api/v1/users/update/profile', {
        json: {
          firstName: values?.firstName,
          lastName: values?.lastName,
          email: values?.email,
          linkedInUrl: values?.linkedInUrl,
          gender: toUpper(values?.gender?.value),
          bio: values?.bio,
          phone: values?.phone,
        },
        parseJson: true,
      });
      onSave(rez);
    } catch (err) {
      await handleSubmitErrors(appContext, err, setError);
    }
  };
  
  return (
    <FormProvider {...formMethods}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <FormText label="First name" name="firstName" required={true} readOnly={readOnly} />
        <FormText label="Last name" name="lastName" required={true} readOnly={readOnly} />
        <FormText label="Email" name="email" required={true} readOnly={readOnly} />
        <FormText label="Linkedin profile" name="linkedInUrl" required={true} readOnly={readOnly} />
        <FormText label="Phone" name="phone" required={true} readOnly={readOnly} />
        <FormCombobox
          label="Gender"
          name="gender"
          required={true}
          options={[
            {label: 'Male', value: 'Male'},
            {label: 'Female', value: 'Female'},
          ]}
          isMulti={false}
          readOnly={readOnly}
        />
        <FormError />
        {!readOnly && (
          <ButtonPanel
            buttons={[
              <FormSubmit key="save">Save</FormSubmit>,
              <FormCancel key="cancel" actionHandler={onClose}>Cancel</FormCancel>,
            ]}
          />
        )}
      </form>
    </FormProvider>
  );
}
